import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Avatar, Button, Paper, Grid, Typography, TextField} from '@material-ui/core';
import LockOpenRoundedIcon from '@material-ui/icons/LockOpenRounded';
import useStyles from './styles';
import Input from './Input';
import {signin, signup, register} from '../../actions/auth';
import {Container, Row, Col} from 'react-bootstrap'
import SchoolIcon from '@material-ui/icons/School';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import {Form} from 'react-bootstrap'
import SlideShow from './SlideShow';
import Navbar from '../Common/Navbar';
import Closing from '../Common/Closing';


const initialState = {firstName: '', lastName: '', email: '', password: '', confirmPassword: '', major: '', collegeName: '', collegeYear: '', latitude: '', longitude: ''};
const initialRegisterState = {emailAddress: '', collegeName: ''}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Auth = () => {
    
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    
    const [showPassword, setshowPassword] = useState(false);
    const [isSignup, setisSignup] = useState(false);
    const [formData, setFormData] = useState(initialState);
    const [open, setOpen] = React.useState(false);
    const [registerData, setRegisterData] = useState(initialRegisterState)
    
    
    const handleSubmit = (event) =>{
        event.preventDefault();
        if(isSignup){
            dispatch(signup(formData, history))
        } else{
            dispatch(signin(formData, history)) 
        }
    };
    
    const clear = () => {
      setRegisterData({emailAddress: '', collegeName: ''});
    }

    const handleRegisterSubmit = (event) =>{
      event.preventDefault();
      dispatch(register(registerData))
      setOpen(true);
      clear();
    };

    const handleChange = (e) =>{
      if (isSignup && formData.latitude.length === 0){
        navigator.geolocation.getCurrentPosition(function(position) {
          setFormData({...formData, latitude:position.coords.latitude, longitude: position.coords.longitude })
        });
      }  
        setFormData({...formData, [e.target.name]: e.target.value});
    };

    const handleRegisterChange = (e) =>{
      setRegisterData({...registerData, [e.target.name]: e.target.value});
    };
    
    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setOpen(false);
    };

    const handleShowPassword = () => setshowPassword((prevshowPassword) => !prevshowPassword);
    
    const switchMode = () => {
        setisSignup((previsSignup) => !previsSignup);
        setshowPassword(false);
    };
   
    
    return (
        <div>
          <Navbar homepage = {true} />
          <Container>
            <Row>
              <Col sm={8}>
                <Paper className = {classes.paper} >
                  <SlideShow />
                </ Paper>
              </Col>
              <Col sm={4}>
                <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                  <Alert onClose={handleClose} severity="success">
                    Your email has been registered. You will be notified about the updates soon.
                  </Alert>
                </Snackbar>
                {!isSignup &&  
                  <> 
                    <Container component = "main" maxWidth = "xs">
                      <Paper className = {classes.paper} >
                        <Avatar className={classes.blue}>
                          <SchoolIcon color= "primary" />
                        </Avatar>
                        <Typography variant = "h5">Register your College </Typography>
                        <form className = {classes.form} onSubmit = {handleRegisterSubmit}>
                          <Grid xs = {12} container spacing = {1}>
                            <Grid item xs = {12} sm = {12}>
                            <Form.Group style = {{paddingBottom: '3px'}} controlId="exampleForm.ControlInput1">
                              <Form.Control style={{ height: '55px'}} required  type = "email" onChange = {handleRegisterChange} placeholder = "Email Address *" name = "emailAddress" value = {registerData.emailAddress} />
                            </Form.Group>
                            </Grid>
                            <Grid item xs = {12} sm = {12}>
                            <Form.Group style = {{position: 'relative', top:'-1px' }} controlId="exampleForm.ControlInput1">
                              <Form.Control style={{ height: '55px'}} required onChange = {handleRegisterChange} placeholder = "College Name *" name = "collegeName" value = {registerData.collegeName} />
                            </Form.Group>
                            </Grid>
                            
                          </Grid>
                          < br />
                          <Grid item>
                            <Button type = "submit" fullWidth variant = "contained" color = "primary" className = {classes.Submit}>
                              Submit
                            </Button>
                          </Grid>        
                        </form>  
                      </Paper>
                    </Container>     
                  </>
                }
                <Container component = "main" maxWidth = "xs">
                  <Paper className = {classes.paper} >
                    <Avatar className={classes.blue}>
                        <LockOpenRoundedIcon color= "primary" />
                    </Avatar>
                    <Typography variant = "h5">{isSignup ? "Sign Up" : "Sign In"}</Typography>
                    <form className = {classes.form} onSubmit = {handleSubmit}>
                      <Grid container spacing = {2}>
                        {isSignup && (
                          <>
                            <Input name = "firstName" label = "First Name" handleChange = {handleChange} autoFocus half />
                            <Input name = "lastName" label = "Last Name" handleChange = {handleChange} half />
                            <Input name = "collegeYear" label = "Year In College" handleChange = {handleChange} />
                            <Input name = "collegeName" label = "College Name" handleChange = {handleChange}/>
                            <Input name = "major" label = "Major" handleChange = {handleChange}/>  
                          </>
                        )}
                        <Input name = "email" label = "Email Address" handleChange = {handleChange} type = "email" />
                        <Input name = "password" label = "Password" handleChange = {handleChange} type = {showPassword ? "text" : "password"} handleShowPassword = {handleShowPassword}/>
                        {isSignup && <Input name = "confirmPassword" label = "Repeat Password" handleChange = {handleChange} type = "password"/>}    
                      </Grid>
                      <br />
                      <Button type = "submit" fullWidth variant = "contained" color = "primary" className = {classes.Submit}> 
                          {isSignup ? "Sign Up" : "Sign In"}
                      </Button>
                      <Grid container justify = "flex-end">
                        <Grid item>
                          <Button onClick = {switchMode}>
                            {isSignup ? "Already have an account? Sign In" : "Don't have an account? Sign Up"}
                          </Button>
                        </Grid>
                      </Grid>
                    </form>
                  </Paper>     
                </Container>
              </Col>
            </Row>
          </Container>
          <Closing />
        </div>
    );
};

export default Auth;
//style = {{paddingBottom: '10px', paddingLeft:'0.5vw' }}
// style={{ height: '55px', width: '22vw', paddingBottom: '30px', paddingTop: '30px'}}
// style = {{paddingLeft:'7.5px' }} 
// style={{ height: '55px', width: '335px', paddingBottom: '30px', paddingTop: '30px' }}